"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwitchGroup = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _SwitchGroup = require("./SwitchGroup.styles");
var _excluded = ["children"];
var getChildProps = function getChildProps(_ref) {
  var size = _ref.size,
    fluid = _ref.fluid,
    labelPosition = _ref.labelPosition;
  var props = {
    fluid: fluid,
    labelPosition: labelPosition
  };
  if (typeof size !== 'undefined') {
    props.size = size;
  }
  return props;
};

/**
 * A collection of labeled `Switch` components.
 *
 * @since 6.7.0
 */
var SwitchGroup = function SwitchGroup(_ref2) {
  var children = _ref2.children,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return /*#__PURE__*/_react.default.createElement(_SwitchGroup.StyledSwitchGroup, props, _react.Children.map(children, function (child) {
    return /*#__PURE__*/(0, _react.cloneElement)(child, getChildProps(props));
  }));
};
exports.SwitchGroup = SwitchGroup;
SwitchGroup.displayName = 'SwitchGroup';
SwitchGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Labeled `Switch` elements in the group */
  children: _propTypes.default.node.isRequired,
  /**
   * Set `size` for all child `Switch` components.
   * If defined, this will override any `size` value set on the individual components.
   */
  size: _propTypes.default.oneOf(Object.values(_constants.SWITCH_SIZES)),
  /** `SwitchGroup` sets `LabeledControl` to be `fluid` by default */
  fluid: _propTypes.default.bool,
  /** `SwitchGroup` sets `LabeledControl` to have `left` positioned labels by default */
  labelPosition: _propTypes.default.oneOf(['left', 'right'])
} : {};
SwitchGroup.defaultProps = {
  size: undefined,
  fluid: true,
  labelPosition: 'left'
};